import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { ITopElement } from "backend/model/model";
import { t } from "i18next";
import { THierarchyMode } from "qpr-base/configuration/types";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { getElementName } from "qpr-base/tplutils/utils";
import React, { useState } from "react";
import { If, Then } from "react-if";
import TruncateMarkup from "react-truncate-markup";
import { MappedData as Element, MappedData } from "./index.dto";

const getTranslatedName = (
  element: any,
  topelements: ITopElement[],
  lang: string
): string => {
  if (element.typename === "Scorecard") {
    const topelement = topelements.find(
      (el: any) => el.id === element.topelementid
    );
    return topelement ? getElementName(topelement, lang) : "undefined";
  }
  return getElementName(
    { ...element, ...{ JS_ATTR: element.translations } },
    lang
  );
};

function CategoryOpen(props: {
  element: Element;
  topElements: ITopElement[];
  onCategorySelected: (id: Element | null, id2?: Element | null) => void;
  open: boolean;
  closedCategoryHighlightClass: string;
  hierarchyMode: THierarchyMode;
  onElementSelected: (element: MappedData | undefined) => void;
}) {
  const [selectedItem, setselectedItem] = useState<number | undefined>();
  const ctx = useAppContext();

  return (
    <div className="category-open">
      <div
        className="categoryTitle"
        onClick={() => {
          if (selectedItem === undefined) {
            props.onCategorySelected(null);
            props.onElementSelected(undefined);
          } else {
            // props.onCategorySelected(props.element, undefined);

            props.onCategorySelected(
              props.element,
              props.element?.childelements
                ? props.element.childelements[selectedItem]
                : undefined
            );

            props.onElementSelected(props.element);
            setselectedItem(undefined);
          }
        }}
        aria-hidden
      >
        <TruncateMarkup lines={3}>
          <h3>
            {getTranslatedName(props.element, props.topElements, ctx.language)}
          </h3>
        </TruncateMarkup>
        {props.element.childelements?.length > 0 ? <ExpandLessIcon /> : null}
        <If condition={selectedItem === undefined}>
          <Then>
            <div className="highlightArea">
              <div />
            </div>
          </Then>
        </If>
      </div>

      {props.element.childelements.length > 0 ? (
        <div className="items">
          <h6 className="subtitle">
            {t(
              `${
                props.hierarchyMode === "Scorecards"
                  ? t("configtypes.Departments")
                  : t("configtypes.Strategic Objectives")
              }`
            )}
          </h6>
          {props.element.childelements?.map((childelement, idx) => {
            return (
              <div>
                <TruncateMarkup
                  lines={props.element.childelements?.length > 0 ? 3 : 1}
                >
                  <span
                    title={getTranslatedName(
                      childelement,
                      props.topElements,
                      ctx.language
                    )}
                    aria-hidden
                    key={idx}
                    onClick={() => {
                      setselectedItem(idx);
                      props.onCategorySelected(props.element, childelement);

                      props.onElementSelected(childelement);
                    }}
                  >
                    {getTranslatedName(
                      childelement,
                      props.topElements,
                      ctx.language
                    )}
                  </span>
                </TruncateMarkup>
                <div
                  className={selectedItem === idx ? "highlightArea" : ""}
                  aria-hidden
                  onClick={() => {
                    setselectedItem(undefined);

                    props.onCategorySelected(props.element, childelement);

                    props.onElementSelected(childelement);
                  }}
                >
                  <div />
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

function CategoryClosed(props: {
  element: Element;
  topElements: ITopElement[];
  onCategorySelected: (id: Element | null) => void;
  open: boolean;
  closedCategoryHighlightClass: string;
  onElementSelected: (element: MappedData | undefined) => void;
}) {
  const ctx = useAppContext();

  const getArrowIcon = () => {
    if (props.element.childelements.length === 0) return null;
    return ctx.rtl ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />;
  };

  return (
    <>
      <div
        className="category-closed"
        aria-hidden
        onClick={() => {
          props.onCategorySelected(props.element);

          props.onElementSelected(props.element);
        }}
      >
        <div className={`categoryTitle ${props.closedCategoryHighlightClass}`}>
          <span
            title={getTranslatedName(
              props.element,
              props.topElements,
              ctx.language
            )}
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {getTranslatedName(props.element, props.topElements, ctx.language)}
          </span>
          {getArrowIcon()}
        </div>
        <div className="hoverArea" />
      </div>
    </>
  );
}

export default function Category(props: {
  element: Element;
  topElements: ITopElement[];
  onCategorySelected: (id: Element | null, id2?: Element | null) => void;
  open: boolean;
  hierarchyMode: THierarchyMode;
  closedCategoryHighlightClass: string;
  onElementSelected: (element: MappedData | undefined) => void;
}) {
  return props.open ? (
    <CategoryOpen {...props} />
  ) : (
    <CategoryClosed {...props} />
  );
}
